export const SECOND_IN_MS = 1000;
export const MINUTE_IN_MS = 60 * SECOND_IN_MS;
export const HOUR_IN_MS = 60 * MINUTE_IN_MS;
export const DAY_IN_MS = 24 * HOUR_IN_MS;

export const shortCacheOptions = {
  staleTime: 5 * MINUTE_IN_MS,
  gcTime: DAY_IN_MS,
};
